module.exports = __webpack_public_path__ + "media/images/map_icons/Camping-5ffc14e9328f2b452a71206f9881cd82.svg";